import React, { useCallback, useState, useEffect } from "react";
import Toast from "../LoadingError/Toast";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";
import axios from "axios";
import { Box, Button, Checkbox, FormControl, FormLabel, Heading, Image, Input, Text } from "@chakra-ui/react";
import { SLIDER_UPDATE_RESET } from "../../Redux/Constants/SliderConstans";
import { SliderEditAction, SliderUpdateAction } from "../../Redux/Actions/SliderAction";
import MainPanel from "../main-panel/MainPanel";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const EditSliderMain = (props) => {
  const { sliderId } = props;
  console.log(sliderId)
  let DefaultLanguageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];

  const [photoUrl, setPhotoUrl] = useState("");
  const [status, setStatus] = useState(false);
  const [language, setLanguage] = useState([]);
  const [imageTitle, setImageTitle] = useState("");
  const [imageAlt, setImageAlt] = useState("");
  const dispatch = useDispatch();

  const handlePicture = async (e) => {
    const file = e.target.files[0]; 
    if (!file) return;
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const { data } = await axios.post(`${BASE_URL}/file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setPhotoUrl(data);
    } catch (error) {
      toast.error("Failed to upload image", ToastObjects);
    }
  };
  


  const onHandleLangChange = useCallback(
    (dataInfo) => {
      let languageList = {
        sliderId: parseInt(sliderId),
        id: parseInt(dataInfo.id),
        name: dataInfo.name,
        status:dataInfo.status,
        description: dataInfo.description,
        seoTitle: dataInfo.seoTitle,
        seoDescription: dataInfo.seoDescription,
        languageKey: dataInfo.lang,
      };
      setLanguage((ln) => [
        ...ln.filter(
          (l) => l.languageKey !== dataInfo.lang && l.languageKey !== "" && typeof (l.languageKey) != 'undefined'
        ),
        languageList,
      ]);
    },
    [sliderId]
  );


  const sliderEdit = useSelector((state) => state.sliderEdit);
  const { loading, error, slider } = sliderEdit;

  const sliderUpdate = useSelector((state) => state.sliderUpdate);
  const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = sliderUpdate;


  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: SLIDER_UPDATE_RESET });
      toast.success("Slider Updated", ToastObjects);
    } else {
      if (!slider || slider.id !== parseInt(sliderId)) {
        dispatch(SliderEditAction(sliderId));
      } else {
        setLanguage(slider.sliderRecord);
        setPhotoUrl(slider.photoUrl);
        setStatus(slider.status)
        setImageTitle(slider.imageTitle || "");
        setImageAlt(slider.imageAlt || "");
      }
    }
  }, [slider, dispatch, sliderId, successUpdate]);


  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      SliderUpdateAction({
        id: sliderId,
        photoUrl,
        status,
        imageTitle,
        imageAlt,
        sliderRecord: language.filter((l) => l.languageKey !== "" && typeof (l.languageKey) != 'undefined'),
      })
    );
  };

  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <div className="content-header" style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              as={Link}
              to="/sliders"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to sliders
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Update Slider
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </div>
          <Box mt={4}>
            <Box className="card mb-4 shadow-sm" borderRadius="md" boxShadow="lg" p={5}>
              {error && <Message variant="alert-danger">{error.toString()}</Message>}

              {loadingUpdate && <Loading />}
              {loading ? (
                <Loading />
              ) : error ? (
                <Message variant="alert-danger">{error}</Message>
              ) : (
                <>
                  <MainPanel
                    mainLang={DefaultLanguageList}
                    languageInfo={language}
                    changeLang={onHandleLangChange}
                  />
                  <FormControl mb={4}>
                    <Text fontSize="lg" fontWeight="semibold">
                      Status
                    </Text>
                    <Checkbox
                      size="lg"
                      colorScheme="teal"
                      isChecked={status}
                      onChange={(e) => setStatus(e.target.checked)}
                    >
                      Active
                    </Checkbox>
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>Images</FormLabel>
              
                      <Input type="file" onChange={handlePicture} />
                    <Box
                      mt={3}
                      width="300px"
                      height="250px"
                      overflow="hidden"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      bgcolor="lightgray" // Optional: To show the box clearly
                    >
                      <Image
                        src={PICTURE_URL + photoUrl}
                        alt="Uploaded Image"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                        }}
                      />
                    </Box>
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel htmlFor="image_title">Image Title</FormLabel>
                    <Input
                      type="text"
                      id="image_title"
                      value={imageTitle}
                      onChange={(e) => setImageTitle(e.target.value)}
                      placeholder="Enter image title"
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
                    <Input
                      type="text"
                      id="image_alt"
                      value={imageAlt}
                      onChange={(e) => setImageAlt(e.target.value)}
                      placeholder="Enter image alt text"
                    />
                  </FormControl>
                </>
              )}
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditSliderMain;